import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { equipmentOptions } from '@/components/training/exerciseData';
import { cn } from '@/lib/utils';

export default function EquipmentSelector({ value, onChange }) {
  const toggleEquipment = (eq) => {
    if (value.includes(eq)) {
      // Don't allow empty selection
      if (value.length > 1) {
        onChange(value.filter((v) => v !== eq));
      }
    } else {
      onChange([...value, eq]);
    }
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-slate-700">
        Available Equipment
        <span className="font-normal text-slate-500 ml-2">(select all that apply)</span>
      </label>
      <div className="grid grid-cols-2 gap-3">
        {equipmentOptions.map((eq, index) => {
          const isSelected = value.includes(eq.value);
          return (
            <motion.button
              key={eq.value}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.05 }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="button"
              onClick={() => toggleEquipment(eq.value)}
              className={cn(
                'relative p-4 rounded-2xl border-2 transition-all duration-300',
                'flex items-center gap-3',
                isSelected
                  ? 'border-cyan-400 bg-gradient-to-br from-cyan-50 to-sky-50 shadow-md'
                  : 'border-slate-200 bg-white hover:border-slate-300',
              )}
            >
              <div
                className={cn(
                  'w-6 h-6 rounded-lg flex items-center justify-center transition-all',
                  isSelected ? 'bg-gradient-to-br from-cyan-400 to-sky-500' : 'bg-slate-100',
                )}
              >
                {isSelected && (
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: 'spring', bounce: 0.5 }}
                  >
                    <Check className="w-4 h-4 text-white" />
                  </motion.div>
                )}
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xl">{eq.icon}</span>
                <span
                  className={cn(
                    'font-medium transition-colors',
                    isSelected ? 'text-cyan-700' : 'text-slate-600',
                  )}
                >
                  {eq.label}
                </span>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
